
import React, { useRef } from 'react';
import { DataGrid } from 'devextreme-react';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import { Column, Editing, Lookup, Pager, Paging, Summary, TotalItem } from 'devextreme-react/data-grid';
import { cellRender, formatId, formatToMoney, dataFormatId } from '../../utils/common';
import { formatDate } from '../../data/app';
import { onCellPreparedReceipt } from './CellPrepared';
import BlockHeader from '../shared/BlockHeader';
import urlReport from '../../services/reportServices';

const DetailTemplate = props => {

    const { onSave } = props;

    const refGrid = useRef();

    const addMenuItems =(e) => {
        
        if (e.target == "content") {
            
            // e.items can be undefined
            if (!e.items) e.items = [];
 
            // Add a custom menu item
            if(e.rowIndex >= 0)
                e.items.push({

                    text: `Re-imprimir recibo`,
                    icon : 'print',
                    onItemClick: () => {

                        const report = urlReport();
                        report.print(`${report.receiptTicket(e.row.data.id)}`);
                        
                    }
                    
                },{

                    text: `Anular recibo`,
                    icon : 'remove',
                    onItemClick: () => refGrid.current.instance.deleteRow(e.rowIndex),                    
                    color : 'red'
                });
           
        }
    } 

    const onRowRemoved = (e) => {
        onSave();
    }

    const { id } = props.data?.data;
    const title = "Recibos generados";

    return (<>
        <BlockHeader title={title} />
               
        <DataGrid
            id="gridReceipt"
            ref={refGrid}
            selection={{ mode: 'single' }}
            dataSource={store({ uri: { get : uri.receivables.byBill(id), remove : uri.receivables.remove } })}
            showBorders={true}
            showRowLines={true}
            allowColumnResizing={true}
            allowColumnReordering={true}
            rowAlternationEnabled={true}
            onContextMenuPreparing={addMenuItems}
            // onRowPrepared={onRowPrepared}
            // onToolbarPreparing={onToolbarPreparing}
            onCellPrepared={onCellPreparedReceipt}     
            onRowRemoved={onRowRemoved}      
        >
            <Paging defaultPageSize={20} />
            <Pager
                showInfo={true}
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
            />
            <Column dataField="id" caption="Id" width={100} cellRender={dataFormatId} visible={false} />
            <Column dataField="numberReceipt" caption="Recibo #" width={100} cellRender={dataFormatId} />
            <Column dataField="date" caption="Fecha" dataType='date' format={formatDate} width={120} />
            <Column dataField="amount" caption="Pagado"  width={120} cellRender={cellRender()} />
            <Column dataField="balance" caption="Pendiente"  width={120} cellRender={cellRender()} />
            <Column dataField="observation" caption="Observacion"  />
            <Column dataField="createBy" caption='Creado por' width={100} />
            <Column dataField="createAt" caption="Creado el" dataType='date' format={formatDate} width={120} />
            <Summary>                
                <TotalItem
                    column="amount"
                    summaryType="sum" 
                    customizeText={data => `Total: ${formatToMoney(data.value)}`} />
            </Summary>
            <Editing
                mode="popup"
                allowDeleting={true}
                useIcons={true}
            ></Editing>
        </DataGrid>
    </>);
};




function getProviders(data, providers) {

    if (data.itemProviders != null) {
        return providers.filter(x => data.itemProviders.some(p => p.providerId == x.id));
    }
    return [];
}

export default DetailTemplate;
